"use client";

import { forwardRef } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../Select";

type SelectInputProps = {
  options: Array<{ label: string; value: string }>;
  placeholder: string;
  value?: string;
  onChange?: (value: string) => void;
  hasError?: boolean;
  optionSize?: "sm" | "base";
};

export const SelectInput = forwardRef<HTMLButtonElement, SelectInputProps>(
  (
    { options, placeholder, value, onChange, hasError, optionSize = "base" },
    ref,
  ) => {
    const selectedOption = options.find((option) => option.value === value);

    return (
      <Select
        onValueChange={onChange}
        value={selectedOption ? selectedOption.value : undefined}
      >
        <SelectTrigger ref={ref} hasError={hasError} className="text-base">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem
              key={option.value}
              value={option.value}
              className={optionSize === "sm" ? "text-sm" : undefined}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);
SelectInput.displayName = "SelectInput";
